module.exports = __webpack_public_path__ + "media/images/brand/200/MARQUESBRANDINGCO LOGO ORIGINAL X-45adbb11e85dc7b9b95124b6b6d53cc1.png";